<div class="bg-white p-3 mb-2 rounded-1 mt-lg-5">
    <div class="row">
        <h6>{{ 'si_pts_chrome_dashboard_redo_test_header' | cmsText | async }}</h6>
        <p [appParagraph]="2">{{ 'si_pts_chrome_dashboard_redo_test_paragraph' | cmsText | async }}</p>
    </div>

    <div class="d-grid gap-2 col-12 mt-2">
        <a appStandardButton [routerLink]="'/dialogs/gamtest'">{{ 'si_pts_chrome_dashboard_redo_test_button' | cmsText | async }}</a>
    </div>
</div>
